export enum ImagePlaceholders {
    // see https://nextjs.org/docs/api-reference/next/image#blurdataurl for how this can be used
    BasicBlur = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
}
